var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.286 28a7.4 7.4 0 01-2.857.571A8.228 8.228 0 0113.572 20a8.229 8.229 0 017.857-8.571c.795.005 1.585.13 2.343.371M10 17.143h8.571M10 22.857h8.571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 38.571c10.257 0 18.572-8.314 18.572-18.571C38.572 9.743 30.257 1.429 20 1.429S1.429 9.743 1.429 20c0 10.257 8.314 18.571 18.571 18.571z"
  })));
}
export default SvgEuro;